import { BeeIcon } from './BeeIcon';

/**
 * author: Google
 * id 8B580447-CD93-41E8-BDB0-F37DAE420D3A
 * name bee
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bee.svg
 * tags
 * - Nature 
 * - Agriculture 
 * - Animal 
 */
export const InsectIcon = BeeIcon;
export default InsectIcon